import { useEffect, useState } from "react";
import { eligible, OFF, parseFlag } from "./flag";
import { platformNewCabinet } from "../../shared/stores/new-cabinet";
/**
 * Флаг раскатки из public/*.json: null — ещё не прочитан, дальше
 * true/false. Тот же разбор и те же правила (учётка И объект), что у R3.
 */
export function useRolloutFlag(
  account: number,
  platform: number,
  url: string,
  /** R3 гаснет в фоновой вкладке; форма с черновиком — нет. */
  hideWhenHidden = true
): boolean | null {
  const [flag, setFlag] = useState<typeof OFF | null>(null);
  useEffect(() => {
    let live = true,
      seq = 0;
    let c: AbortController | undefined;
    const refresh = async () => {
      const mine = ++seq;
      c?.abort();
      c = new AbortController();
      const own = c;
      const timeout = setTimeout(() => own.abort(), 3000);
      try {
        const r = await fetch(url, {
          cache: "no-store",
          signal: own.signal,
        });
        if (!r.ok) throw Error();
        const next = parseFlag(await r.json());
        if (live && mine === seq) setFlag(next);
      } catch {
        if (live && mine === seq) setFlag(OFF);
      } finally {
        clearTimeout(timeout);
      }
    };
    const focus = () => {
      if (document.visibilityState === "visible") void refresh();
      else if (hideWhenHidden) setFlag(OFF);
    };
    void refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener("focus", focus);
    document.addEventListener("visibilitychange", focus);
    return () => {
      live = false;
      seq++;
      c?.abort();
      clearInterval(timer);
      window.removeEventListener("focus", focus);
      document.removeEventListener("visibilitychange", focus);
    };
  }, [url, hideWhenHidden]);
  return flag === null ? null : eligible(flag, account, platform);
}

export function useCockpitFlag(account: number, platform: number) {
  const pilot = !!useRolloutFlag(account, platform, "/cockpit-r3.json");
  return pilot || platformNewCabinet(platform);
}
